import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '@services/authentication.service';
import { ToastService } from '@services/toast.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

interface NavigationItem {
  labelKey: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-root',
  templateUrl: 'root.component.html',
  styleUrl: 'root.component.scss',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    RouterModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class RootComponent {
  private readonly authService = inject(AuthenticationService);
  private readonly router = inject(Router);
  private readonly toastService = inject(ToastService);
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly translateService = inject(TranslateService);

  readonly navigationItems: NavigationItem[] = [
    { labelKey: 'nav.dashboard', icon: 'dashboard', route: '/dashboard' },
    { labelKey: 'nav.water-services', icon: 'room_service', route: '/water-services' },
    { labelKey: 'nav.push-notifications', icon: 'notifications', route: '/push-notifications' },
  ];

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  async logout(): Promise<void> {
    try {
      this.authService.logout();
      await this.router.navigate(['/login']);
    } catch (error) {
      console.error('Logout error:', error);
      this.toastService.showError(this.translateService.instant('logout.error'));
    }
  }
}
